import { createFileRoute, redirect, Link } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { TaskCategoriesClient } from "@/features/tasks/TaskCategoriesClient";
import { listTaskCategories, tasksKeys } from "@/features/tasks/tasks.api";
import { listMailboxes, mailKeys } from "@/features/mail/mail.api";

export const Route = createFileRoute("/_shell/tasks/categories")({
  // No admin gate any more: everyone manages their own kenmerken, and members
  // manage their mailbox's. The module gate on the API is the real boundary.
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tasks")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: TaskCategoriesScreen,
});

function TaskCategoriesScreen() {
  const { t } = useTranslation();

  // Which lists you may add to: your own, plus the mailboxes you are in.
  const mailboxesQuery = useQuery({
    queryKey: mailKeys.mailboxes,
    queryFn: () => listMailboxes(),
  });
  const session = Route.useRouteContext().session;
  const myMailboxes = (mailboxesQuery.data ?? []).filter((m) =>
    m.members.some((mem) => mem.id === session.userId),
  );

  const categoriesQuery = useQuery({
    queryKey: tasksKeys.categoriesManage,
    queryFn: () => listTaskCategories(true, "all"),
  });

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Task Categories">
      <div style={{ marginBottom: "16px" }}>
        <Link
          to="/tasks"
          className="t-caption"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px", color: "var(--text-secondary)" }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {t("tasks.backToOverview")}
        </Link>
      </div>

      <TaskCategoriesClient
        mailboxes={myMailboxes}
        initialItems={categoriesQuery.data ?? []}
        userId={session.userId}
        isFetching={categoriesQuery.isFetching}
        isLoading={categoriesQuery.isLoading}
      />
    </div>
  );
}
